import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import BookingService from './../../../services/cargobooking.service';
import CONSTANT from './../../../../shared/constants/constant';
import ClientService from './../../../../clientmanagement/services/clientmanagement.service';

export default {
  name: 'printmps',
  components: {
    VueElementLoading
  },
  props: ['bookingdata'],
  data: function() {
    return {
      source:"",
      destination:"",
      parentawbno:"",
      mpsdata:[],
      totalmps:"",
      childawb:"",
      SearchValue:"",
      SearchType:"parentawb",
      routemode:"",
      bookingmode:"",
      droppincode:"",
      isLoading: false,
      hubid:"",
      userid:"",
      useremail:"",
      hubname:"",
      field1label : "",
      field1value : "",
      field2label : "",
      field2value : "",
      lmroute : null
    }
  },
  computed: {

  },
  async mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.hubid = userdetail.hubID[0];
    this.userid = userdetail.userid;
    this.useremail = userdetail.email;
    this.hubname=userdetail.currentHubName;
    if (this.bookingdata.bookingmethod != "API") {
      await this.getMPSDetailsByBookingId();
    }
    this.source=this.bookingdata.originhub;
    this.destination=this.bookingdata.destinationhubs
  },
  methods: {
    async getMPSDetailsByBookingId(){
      try {
        this.isLoading = true;
        let inputPayload = {
          SearchValue:this.bookingdata.awbnumber,
          SearchType:this.SearchType
        };
        let result = await BookingService.PrintMpsStickers(inputPayload);
        if(result.data.code==200){
          this.totalmps = result.data.data.noofmps;
          this.routemode =result.data.data.routemode;
          this.bookingmode =result.data.data.bookingmode;
          this.source =result.data.data.originhubname;
          this.parentawbno = result.data.data.parentawbno;
          this.destination =result.data.data.destinationhunname;
          this.droppincode= result.data.data.droppincode;
          this.field1label = result.data.data.field1label
          this.field1value = result.data.data.field1value
          this.field2label = result.data.data.field2label
          this.field2value = result.data.data.field2value
          this.lmroute = result.data.data.lmroute
          result.data.data.childmps.forEach((item, i) => {
            this.mpsdata.push(result.data.data.childmps[i]);
          });
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
    },
    async PrintMPSALL(){
      try{
          let inputPayload = {};
          let mpsdetails = [];
          let inputPayload1 = {};
          let mpslogdetails = [];
          for(let i=0;i<this.mpsdata.length;i++){
            let pincodeStr = this.droppincode
            if (this.lmroute) {
              pincodeStr = this.droppincode + " - " + this.lmroute
            }
            let tempObj = {
            originhub : this.source,
            destinationhubs : this.destination,
            awbnumber :this.parentawbno,
            totalmps :this.totalmps,
            routemode :this.routemode,
            bookingmode :this.bookingmode,
            droppincode : pincodeStr,
            childawb:this.mpsdata[i].childmpsno,
            sequence: this.mpsdata[i].serialnum,
            field1label : this.mpsdata[i].field1label,
            field1value : this.mpsdata[i].field1value,
            field2label : this.mpsdata[i].field2label,
            field2value : this.mpsdata[i].field2value,
          }
          mpsdetails.push(tempObj);
          let mpslog={
            MPSNo:this.mpsdata[i].childmpsno,
            AWBNo:this.parentawbno,
            loggedinhubid:this.hubid,
            hubname:this.hubname,
            userid:this.userid,
            useremail:this.useremail,
            printtype:"Print All",
            source:"Web"
          }
          mpslogdetails.push(mpslog);
        }
        inputPayload1.mpslogdetails=mpslogdetails
        inputPayload.mpsdetails=mpsdetails
        this.isLoading = true;
        let awbresult = await BookingService.printmps(inputPayload)
        this.isLoading = false;
        if (awbresult.data && awbresult.data.code==200)
        {
          let printmpslogsresult=BookingService.printmpslogs(inputPayload1);
          this.$alert(awbresult.data.message, "", "success");
        }
        else{
          this.$alert("Please Install Printing Device", "", "error");
        }
      }
      catch(err){
        this.isLoading = false;
        this.$alert(err, "", "error");
        console.log(err);
      }
    },
    async PrintMPS(id,data){
      try{
          let inputPayload = {};
          let inputPayload1 = {};
          let mpslogdetails=[];
          let mpsdetails = [];
          let pincodeStr = this.droppincode
          if (this.lmroute) {
            pincodeStr = this.droppincode + " - " + this.lmroute
          }
          let tempObj = {
          originhub : this.source,
          destinationhubs : this.destination,
          awbnumber :this.parentawbno,
          totalmps :this.totalmps,
          routemode :this.routemode,
          bookingmode :this.bookingmode,
          droppincode : pincodeStr,
          childawb:data.childmpsno,
          sequence: id,
          field1label : data.field1label,
          field1value : data.field1value,
          field2label : data.field2label,
          field2value : data.field2value,
        }
        mpsdetails.push(tempObj);
        inputPayload.mpsdetails=mpsdetails;
        let mpslog={
          MPSNo:data.childmps,
          AWBNo:this.parentawbno,
          loggedinhubid:this.hubid,
          hubname:this.hubname,
          userid:this.userid,
          useremail:this.useremail,
          printtype:"Individual Print",
          source:"Web"
        }
        mpslogdetails.push(mpslog);
        inputPayload1.mpslogdetails=mpslogdetails;
        this.isLoading = true;
        let awbresult = await BookingService.printmps(inputPayload)

        this.isLoading = false;
        if (awbresult.data && awbresult.data.code==200)
        {
          //calling log api
          let printmpslogsresult=BookingService.printmpslogs(inputPayload1)
          this.$alert(awbresult.data.message, "", "success");
        }
        else{
          this.$alert("Please Install Printing Device", "", "error");
        }
      }
      catch(err){
        this.isLoading = false;
        this.$alert(err, "", "error");
        console.log(err);
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargobooking/views/booking/printmps/printmps.component.js